import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'ca-med-tag-studyid-input-field',
    templateUrl: './MED-tag-studyID-input-field.component.html',
    styleUrls: ['./MED-tag-studyID-input-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MEDTagAndStudyIDInputFieldComponent {
    @Input() tags: Array<string> = [];
    @Input() titleKey: string;
    @Input() isFilesPage: boolean;
    @Input() studyIdValue?: string;
    @Input() name?: string;
    @Input() placeholder?: string;
    @Input() isEditTagsDialog?: boolean = false;

    @Output() createTag = new EventEmitter<string>();
    @Output() createStudyId = new EventEmitter<string>();

    @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;

    value = '';
    showIcons = false;
    showTagIcon = true;
    isFormActive = true;

    submitTag(): void {
        if (this.value !== '') {
            this.onSubmitEmitValue(this.titleKey);
            this.value = '';
            this.focusOnInput();
        }
    }

    resetTagInput(): void {
        if (this.value !== '') {
            this.value = '';
            this.showIcons = true;
            this.showTagIcon = false;
            this.focusOnInput();
        } else {
            this.value = '';
            this.showIcons = false;
            this.showTagIcon = true;
        }
    }

    focusOnInput(): void {
        // Keep the focus after pressing the data-uit="create-new-tag"
        if (this.tagInput && this.tagInput.nativeElement) {
            this.tagInput.nativeElement.focus();
        }
    }

    isTagIconShown(): boolean {
        return this.titleKey !== 'studyId';
    }

    isStudyIDInputField(): boolean {
        return this.titleKey === 'studyId';
    }

    onInputBlur(): void {
        if (this.value === '') {
            // Execute the blur logic only if the tag value is empty
            this.showIcons = false;
            this.showTagIcon = true;
        } else {
            this.onSubmitEmitValue(this.titleKey);
        }
    }

    onInputFocus(): void {
        this.showTagIcon = false;
        this.showIcons = true;
    }

    onSubmitEmitValue(titleKey: string): void {
        this.value = this.value.trim();
        if (titleKey === 'studyId' && this.value) {
            this.createStudyId.emit(this.value);
            this.isFormActive = false;
        } else if (titleKey === 'customTags' && this.value) {
            this.createTag.emit(this.value);
        }
    }
}
